export const ORDER_SET_PRODUCT_SKU = 'ORDER_SET_PRODUCT_SKU'
export const ORDER_SET_PRODUCT_ART = 'ORDER_SET_PRODUCT_ART'
export const ORDER_SET_QUANTITY = 'ORDER_SET_QUANTITY'
export const ORDER_SET_LIST = 'ORDER_SET_LIST'
export const ORDER_SET_LIST_DATA = 'ORDER_SET_LIST_DATA'

export const UI_SET_LOADING_ACTION = 'UI_SET_LOADING_ACTION'
